import { useCallback, useState } from 'react';
import { ButtonWrapper } from '@tempusfinance/common-ui';
import { latestBlockAtom } from '../../atoms';
import { Icon, Link, Logo, NavigationSubmenuItem, Typography, Wallet } from '../shared';

import './NavigationMobile.scss';
import { useAtom } from '../../lib';

const NavigationMobile = () => {
  const [latestBlock] = useAtom(latestBlockAtom);

  const [menuOpen, setMenuOpen] = useState(false);

  const openMenu = useCallback(() => {
    setMenuOpen(true);
  }, []);

  const closeMenu = useCallback(() => {
    setMenuOpen(false);
  }, []);

  return (
    <div className="nostra__navigationMobile">
      <Logo type="nostra-full-logo" />
      <div className="nostra__navigationMobile__actions">
        <Wallet />
        <ButtonWrapper onClick={openMenu}>
          <Icon variant="menu" size={24} color="--icon-default-darkbg" />
        </ButtonWrapper>
      </div>
      <div className="nostra__navigationMobile__bottomBar" />

      <div className={`nostra__navigationMobile__menu ${menuOpen ? 'nostra__navigationMobile__menuOpen' : ''}`}>
        <div className="nostra__navigationMobile__menuHeader">
          <Logo type="nostra-full-logo" />
          <ButtonWrapper onClick={closeMenu}>
            <Icon variant="close" size={24} color="--icon-default-darkbg" />
          </ButtonWrapper>
        </div>
        <div className="nostra__navigationMobile__menuLinks">
          <Link href="/" className="nostra__navigationMobile__menuLink" onClick={closeMenu}>
            <div className="nostra__navigationMobile__menuLinkLabel">
              <div className="nostra__navigationMobile__menuLinkIcon">
                <Icon variant="home" size={20} color="--icon-supporting" />
              </div>
              <Typography variant="table-body-lg" weight="semi-bold" color="text-supporting-darkbg">
                Dashboard
              </Typography>
            </div>
            <Icon variant="arrow-right" size={20} color="--text-supporting-darkbg" />
          </Link>
          <Link href="/lend-borrow" className="nostra__navigationMobile__menuLink" onClick={closeMenu}>
            <div className="nostra__navigationMobile__menuLinkLabel">
              <div className="nostra__navigationMobile__menuLinkIcon">
                <Icon variant="coin" size={20} color="--icon-supporting" />
              </div>
              <Typography variant="table-body-lg" weight="semi-bold" color="text-supporting-darkbg">
                Lend & Borrow
              </Typography>
            </div>
            <Icon variant="arrow-right" size={20} color="--text-supporting-darkbg" />
          </Link>
          <Link href="/swap" className="nostra__navigationMobile__menuLink" onClick={closeMenu}>
            <div className="nostra__navigationMobile__menuLinkLabel">
              <div className="nostra__navigationMobile__menuLinkIcon">
                <Icon variant="swap" size={20} color="--icon-supporting" />
              </div>
              <Typography variant="table-body-lg" weight="semi-bold" color="text-supporting-darkbg">
                Swap
              </Typography>
            </div>
            <Icon variant="arrow-right" size={20} color="--text-supporting-darkbg" />
          </Link>
          <Link href="/pools" className="nostra__navigationMobile__menuLink" onClick={closeMenu}>
            <div className="nostra__navigationMobile__menuLinkLabel">
              <div className="nostra__navigationMobile__menuLinkIcon">
                <Icon variant="pool" size={20} color="--icon-supporting" />
              </div>
              <Typography variant="table-body-lg" weight="semi-bold" color="text-supporting-darkbg">
                Pools
              </Typography>
            </div>
            <Icon variant="arrow-right" size={20} color="--text-supporting-darkbg" />
          </Link>
          <Link href="/bridge" className="nostra__navigationMobile__menuLink" onClick={closeMenu}>
            <div className="nostra__navigationMobile__menuLinkLabel">
              <div className="nostra__navigationMobile__menuLinkIcon">
                <Icon variant="bridge" size={20} color="--icon-supporting" />
              </div>
              <Typography variant="table-body-lg" weight="semi-bold" color="text-supporting-darkbg">
                Bridge
              </Typography>
            </div>
            <Icon variant="arrow-right" size={20} color="--text-supporting-darkbg" />
          </Link>
          <Link href="/claim" className="nostra__navigationMobile__menuLink" onClick={closeMenu}>
            <div className="nostra__navigationMobile__menuLinkLabel">
              <div className="nostra__navigationMobile__menuLinkIcon">
                <Icon variant="spring-rewards" size={20} color="--icon-supporting" />
              </div>
              <Typography variant="table-body-lg" weight="semi-bold" color="text-supporting-darkbg">
                STRK Rewards
              </Typography>
            </div>
            <Icon variant="arrow-right" size={20} color="--text-supporting-darkbg" />
          </Link>
          <NavigationSubmenuItem expanded={true} variant="mobile" onNavigate={closeMenu} />
        </div>
        <div className="nostra__navigationMobile__menuFooter">
          <div className="nostra__navigationMobile__menuFooterLinks">
            <Link href="https://discord.gg/zwa8K3drb" className="nostra__navigationMobile__menuFooterLink">
              <Icon variant="discord" size={20} color="--primary-200" />
            </Link>
            <Link href="https://twitter.com/nostrafinance" className="nostra__navigationMobile__menuFooterLink">
              <Icon variant="x" size={20} color="--primary-200" />
            </Link>
            <Link href="https://docs.nostra.finance/" className="nostra__navigationMobile__menuFooterLink">
              <Icon variant="git-book" size={20} color="--primary-200" />
            </Link>
          </div>
          <div className="nostra__navigationMobile__menuFooterBlockNumber">
            <Typography variant="body-sm" color="text-supporting-darkbg">
              {latestBlock}
            </Typography>
            <div className="nostra__navigationMobile__serviceStatusIconContainer">
              <div className="nostra__navigationMobile__serviceStatusIcon" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default NavigationMobile;
